export const fileTypes = {
	All: 0,
	Request: 1,
	Response: 2,
	Errors: 3,
	Pkgs: 4,
};

export const requestTypes = {
	Analysis: "Analysis",
	Report: "Report",
	Pkg: "Pkg",
	Snapshot: "Snapshot",
};

export const workerStatus = {
	Waiting: "Waiting",
	Processing: "Processing",
	Offline: "Offline",
	Unresponsive: "Unresponsive",
	ShutdownReady: "ShutdownReady",
	Restarting: "Restarting",
	RestartingWatcher: "RestartingWatcher",
	Reimaging: "Reimaging",
};

export const transactionStatus = {
	Queued: "Queued",
	Ingesting: "Ingesting",
	Analyzing: "Analyzing",
	Error: "Error",
	ErrorWillRetry: "ErrorWillRetry",
	UploadingResults: "UploadingResults",
	GeneratingReport: "GeneratingReport",
	Completed: "Completed",
	RebuildingSignals: "RebuildingSignals",
	Converting: "Converting",
	Unknown: "Unknown",
};
